import { render, staticRenderFns } from "./MicMenu.vue?vue&type=template&id=bb27df08&scoped=true&"
import script from "./MicMenu.vue?vue&type=script&lang=js&"
export * from "./MicMenu.vue?vue&type=script&lang=js&"
import style0 from "./MicMenu.vue?vue&type=style&index=0&id=bb27df08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb27df08",
  null
  
)

export default component.exports